<template>
	<div class="p-grid">

		<div class="p-col-12">			
			<div class="card">
				<Panel header="GRADOS ACADÉMICOS OBTENIDOS" style="height: 100%">

				<Toolbar class="p-mb-4">
					<template v-slot:left>
						<Button label="Registrar" icon="pi pi-plus" class="p-button-success p-mr-2" @click="openNew" />						
					</template>
					<template v-slot:right>
						<span class="p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText v-model="filters['global'].value" placeholder="Buscar..." />
                        </span>
					</template>
				</Toolbar>
				
			<DataTable :value="gradosacad" v-model:selection="gradosItem" class="p-datatable-gridlines" dataKey="idGrado" :filters="filters" :rows="5" style="margin-bottom: 20px" :paginator="true"
				responsiveLayout="scroll" :rowsPerPageOptions="[5,10,25]">				
			
				<Column field="nomGrado" header="Nombre del Grado" :sortable="true" style="width:270px"></Column>
				<Column field="areaCon" header="Área Conocimiento" :sortable="true"></Column>
				<Column field="institucion" header="Institución" :sortable="true"></Column>
				<Column field="periodoCursado" header="Periodo Cursado" :sortable="false"></Column>
				<Column field="anTitulacion" header="Año Titulación" :sortable="true" style="width:70px;text-align:center"></Column>
				<Column style="width:140px">
					<template #header>
						Acciones
					</template>
					<template #body="slotProps">
                        <Button icon="pi pi-pencil" type="button" class="p-button-success p-mr-2 p-mb-1" @click="showeditGradosAcad(slotProps.data)"></Button>
                        <Button icon="pi pi-trash" type="button" class="p-button-danger p-mb-1" @click="confirmDeleteGradosAcad(slotProps.data)"></Button>
					</template>
				</Column>
			</DataTable>
				
			</Panel>
			<br>
			<Toast/>

			<Dialog v-model:visible="gradosacadDialog" :style="{width: '470px'}" header="Registrar Grado Académico" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">Nombre del Grado Académico:</label>
						<InputText id="nom" v-model="gradosItem.nomGrado" required="true" autofocus :class="{'p-invalid': submitted && validarErrores.nomGrado}" />
						<small class="p-error" v-show="submitted && validarErrores.nomGrado">El nombre del Grado Académico es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Área de Conocimiento:</label>
						<Dropdown id="area" v-model="gradosItem.area" :options="areasconoc" optionLabel="label" required="true" placeholder="Selecciona área de conocimiento ..." :class="{'p-invalid': submitted && validarErrores.area}" >							
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.label}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value}}</span>
							</div>
							<span v-else>
								{{slotProps.placeholder}}
							</span>
						</template>
						</Dropdown>
					</div>
					<div class="p-field">
						<label for="name">Institución:</label>
						<InputText id="tiempo"  v-model="gradosItem.institucion" required="true" :class="{'p-invalid': submitted && validarErrores.institucion}"/>
						<small class="p-error" v-show="submitted && validarErrores.institucion">El nombre de la Institución es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Periodo cursado:</label>
						<InputText id="nom" v-model="gradosItem.periodoCursado" required="true" :class="{'p-invalid': submitted && validarErrores.periodoCursado}" />
						<small class="p-error" v-show="submitted && validarErrores.periodoCursado">El periodo cursado es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Año Titulación:</label>
						<InputText id="tiempo"  v-model="gradosItem.aTitula" required="true" integeronly :class="{'p-invalid': submitted && validarErrores.atitulacion}"/>
						<small class="p-error" v-show="submitted && validarErrores.atitulacion">El año de Titulación es requerido.</small>
					</div>
								
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialog"/>
						<Button label="Guardar " icon="pi pi-check" class="p-button-primary" @click="saveGradosAcad" />
					</template>
			</Dialog>

			<Dialog v-model:visible="editarDialog" :style="{width: '470px'}" header="Editar Grado Académico" :modal="true" class="p-fluid">
					<div class="p-field">
						<label for="name">Nombre del Grado Académico:</label>
						<InputText id="nom" v-model="gradosItem.nomGrado" required="true" autofocus :class="{'p-invalid': submitted && validarErrores.nomGrado}" />
						<small class="p-error" v-show="submitted && validarErrores.nomGrado">El nombre del Grado Académico es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Área de Conocimiento:</label>
						<Dropdown id="area" v-model="gradosItem.area" :options="areasconoc" optionLabel="label" required="true" placeholder="" :class="{'p-invalid': submitted && validarErrores.area}">
						<template #value="slotProps">
							<div v-if="slotProps.value && slotProps.value.value">
								<span>{{slotProps.value.label}}</span>
							</div>
							<div v-else-if="slotProps.value && !slotProps.value.value">
								<span>{{slotProps.value}}</span>
							</div>
							<span v-else>
								{{slotProps.value}}
							</span>
						</template>
						</Dropdown>
					</div>
					<div class="p-field">
						<label for="name">Institución:</label>
						<InputText id="tiempo"  v-model="gradosItem.institucion" required="true" :class="{'p-invalid': submitted && validarErrores.institucion}"/>
						<small class="p-error" v-show="submitted && validarErrores.institucion">El nombre de la Institución es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Periodo cursado:</label>
						<InputText id="nom" v-model="gradosItem.periodoCursado" required="true" :class="{'p-invalid': submitted && validarErrores.periodoCursado}" />
						<small class="p-error" v-show="submitted && validarErrores.periodoCursado">El periodo cursado es requerido.</small>
					</div>
					<div class="p-field">
						<label for="name">Año Titulación:</label>
						<InputText id="tiempo"  v-model="gradosItem.aTitula" required="true" integeronly :class="{'p-invalid': submitted && validarErrores.atitulacion}"/>
						<small class="p-error" v-show="submitted && validarErrores.atitulacion">El año de Titulación es requerido.</small>
					</div>
								
					
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-danger" @click="hideDialogEditar"/>
						<Button label="Editar " icon="pi pi-check" class="p-button-primary" @click="editGradosAcad" />
					</template>
			</Dialog>


			<Dialog v-model:visible="deleteGradosAcadDialog" :style="{width: '450px'}" header="Confirma eliminación" :modal="true">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
						<span>¿ Deseas eliminar el registro seleccionado ?</span>
					</div>
					<template #footer>
						<Button label="No" icon="pi pi-times" class="p-button-text" @click="deleteGradosAcadDialog = false"/>
						<Button label="Yes" icon="pi pi-check" class="p-button-text" @click="deleteGradosAcad" />
					</template>
			</Dialog>

			</div>			
		</div>
	</div>
</template>
<script>
import apiGradosAcad from '@/service/GradosAcadService';
import { FilterMatchMode } from 'primevue/api';

export default {
		data() {
				return{
					gradosacad: [],
					gradosItem: {
						idGrado: null,
						nomGrado: null,
						area:null,
						institucion:null,
						periodoCursado:null,
						aTitula:null
					},
					gradosacadDialog: false,
					editarDialog: false,
					deleteGradosAcadDialog: false,
					filters: [{
							'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
					}],									
					validarErrores: {},
					submitted: false,
					areasconoc: [
						{label: 'Artes y Humanidades', value: 'Artes y Humanidades'},
						{label: 'Ciencias Agropecuarias', value: 'Ciencias Agropecuarias'},
						{label: 'Ciencias de la Salud', value: 'Ciencias de la Salud'},
						{label: 'Ciencias Sociales y Administrativas', value: 'Ciencias Sociales y Administrativas'},
						{label: 'Ingeniería y Tecnología', value: 'Ingeniería y Tecnología'},
						{label: 'Educación, Humanidades y Arte', value: 'Educación, Humanidades y Arte'}
					]
				}
		},		
		created() {
			this.initialize();
			this.initFilters();
		},
		mounted() {
			this.readGradosAcad(window.localStorage.getItem('noPlaza'));
		},
		methods: {
			initialize () {
			this.readGradosAcad(window.localStorage.getItem('noPlaza'));
			}, 
			readGradosAcad: async function() {   //Leer datos desde el API REST
				const data = await apiGradosAcad.readGradosAcad(window.localStorage.getItem('noPlaza')); //llamar al API 
				this.gradosacad = data;				
			},	
			insertGradosAcad: async function() { 
				const requestData = {
					idGrado: "",        
					nomGrado: this.gradosItem.nomGrado,
					area: this.gradosItem.area.value,
					institucion: this.gradosItem.institucion,
					periodoCursado: this.gradosItem.periodoCursado,
					aTitula: this.gradosItem.aTitula,
					noPlaza: window.localStorage.getItem('noPlaza')
				};
				
				await apiGradosAcad.createGradosAcad(requestData); //Insertar el item mediante API REST     
				this.gradosItem.nomGrado = "";
				this.gradosItem.area = "";
				this.gradosItem.institucion = "";
				this.gradosItem.periodoCursado = "";
				this.gradosItem.aTitula = "";
				this.readGradosAcad(window.localStorage.getItem('noPlaza'));
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Grado Académico registrado', life: 3000});
			},	
			updateGradosAcad: async function() { 
				const requestData = {
					idGrado: this.gradosItem.idGrado,        
					nomGrado: this.gradosItem.nomGrado,
					area: this.gradosItem.area.value,
					institucion: this.gradosItem.institucion,
					periodoCursado: this.gradosItem.periodoCursado,
					aTitula: this.gradosItem.aTitula,
					noPlaza: window.localStorage.getItem('noPlaza')
				};
				
				await apiGradosAcad.updateGradosAcad(this.gradosItem.idGrado,requestData); 
				this.gradosItem.nomGrado = "";
				this.gradosItem.area = "";
				this.gradosItem.institucion = "";
				this.gradosItem.periodoCursado = "";
				this.gradosItem.aTitula = "";
				this.readGradosAcad(window.localStorage.getItem('noPlaza'));
				this.$toast.add({severity:'success', summary: 'Confirmación', detail: 'Grado Académico modificado', life: 3000});
			},
			deleteGradosAcad: async function() {
				await apiGradosAcad.deleteGradosAcad(this.gradosItem.idGrado);								
				this.readGradosAcad(window.localStorage.getItem('noPlaza'));
				this.deleteGradosAcadDialog = false;						
				this.$toast.add({severity:'success', summary: 'Acción correcta', detail: 'Grado Académico eliminado ', life: 3000});
			},
			openNew() {	
				this.submitted = false;
				this.gradosItem={
					idGrado:'',
					nomGrado:'',
					area:'',
					institucion:'',
					periodoCursado:'',
					aTitula:''
				}
				this.gradosacadDialog = true;
			},
			hideDialog() {
				this.gradosacadDialog = false;
				this.submitted = false;
			},
			hideDialogEditar() {
				this.editarDialog = false;
				this.submitted = false;
			},
			initFilters() {
            this.filters = {
				'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
				}
			},
			saveGradosAcad() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.insertGradosAcad();
					this.hideDialog();
				}
			},
			editGradosAcad() {
				this.submitted = true;
				if (this.validarForm() ) {				
					this.updateGradosAcad();
					this.hideDialogEditar();
				}
			},
			validarForm() {
				if (!this.gradosItem.nomGrado.trim())
					this.validarErrores['nomGrado'] = true;
				else
					delete this.validarErrores['nomGrado'];

				if (!this.gradosItem.institucion.trim())
					this.validarErrores['institucion'] = true;
				else
					delete this.validarErrores['institucion'];
				
				if (!this.gradosItem.periodoCursado.trim())
					this.validarErrores['periodo'] = true;
				else
					delete this.validarErrores['periodo'];
				
				if (!this.gradosItem.aTitula.trim())
					this.validarErrores['atitulacion'] = true;
				else
					delete this.validarErrores['atitulacion'];

				return !Object.keys(this.validarErrores).length;
			},		
			confirmDeleteGradosAcad(grados) {				
				this.gradosItem.idGrado = grados.idGrado;				
				this.deleteGradosAcadDialog = true;				
			},
			showeditGradosAcad(gradosdata) {
				//Son los valores de los campos del Datatable
				this.gradosItem={
					idGrado: gradosdata.idGrado,
					nomGrado: gradosdata.nomGrado,
					area: gradosdata.areaCon,
					institucion: gradosdata.institucion,
					periodoCursado: gradosdata.periodoCursado,
					aTitula: gradosdata.anTitulacion
				} 
				this.editarDialog = true;				
			}
		}
	}
</script>

<style scoped lang="scss">
	.table-header {
		display: flex;
		justify-content: space-between;
	}
</style>
